import React, { HTMLAttributes } from 'react';
import { classCombine } from 'tradevan-ui/consts';

const ULinlineTable = (props: HTMLAttributes<HTMLUListElement>) => {
  const { className, ...other } = props;

  return <ul className={classCombine('inline-table', className)} {...other} />;
};

export default ULinlineTable;
